import React from 'react';
import Slider from 'react-slick';
import { allBlogPosts } from '../data/blogPosts';
import { Link } from 'react-router-dom';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const latestBlogs = allBlogPosts.slice(0, 12);

export default function BlogSlider() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3500,
    arrows: false, // <-- Hide arrows
    accessibility: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };

  return (
    <section className="w-full bg-white py-12">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-blue-900 mb-8">
          Latest Blog Posts
        </h2>
        <Slider {...settings}>
          {latestBlogs.map(blog => (
            <div key={blog.slug} className="px-2" aria-label={`Blog: ${blog.title}`}
              style={{ outline: 'none' }}>
              <div className="bg-white rounded-2xl shadow-lg overflow-hidden flex flex-col h-full hover:shadow-blue-200 transition-shadow duration-300">
                {blog.image && (
                  <img
                    src={blog.image}
                    alt={blog.title}
                    className="w-full h-52 object-cover"
                    loading="lazy"
                    sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
                  />
                )}
                <div className="flex-1 flex flex-col px-5 py-4">
                  <h3 className="text-xl font-bold text-blue-900 mb-2 line-clamp-2">{blog.title}</h3>
                  <div className="text-gray-500 text-xs mb-1">{blog.date}</div>
                  <div className="text-gray-700 text-sm mb-3 line-clamp-3">{blog.excerpt}</div>
                  <div className="mt-auto pt-2">
                    <Link
                      to={`/blog/${blog.slug}`}
                      className="inline-block bg-blue-700 text-white px-4 py-1.5 rounded hover:bg-blue-800 transition text-center text-sm"
                      aria-label={`Read more about: ${blog.title}`}
                    >
                      Read More
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
}
